// extracted by mini-css-extract-plugin
export default {"avatar":"JournalEntry_avatar__x5w56"};